import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const toggleSwitchDefaultVariants = {
  "size": "md"
}
const toggleSwitchCompoundVariants = [
  {
    "description": true,
    "descriptionDirection": "vertical",
    "labelPlacement": "left",
    "css": {
      "descriptionWrapper": {
        "alignItems": "flex-end"
      }
    }
  }
]

const toggleSwitchSlotNames = [
  [
    "wrapper",
    "toggleSwitch__wrapper"
  ],
  [
    "root",
    "toggleSwitch__root"
  ],
  [
    "thumb",
    "toggleSwitch__thumb"
  ],
  [
    "descriptionWrapper",
    "toggleSwitch__descriptionWrapper"
  ]
]
const toggleSwitchSlotFns = /* @__PURE__ */ toggleSwitchSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, toggleSwitchDefaultVariants, getSlotCompoundVariant(toggleSwitchCompoundVariants, slotName))])

const toggleSwitchFn = memo((props = {}) => {
  return Object.fromEntries(toggleSwitchSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const toggleSwitchVariantKeys = [
  "size",
  "disabled",
  "description",
  "descriptionDirection",
  "labelPlacement"
]
const getVariantProps = (variants) => ({ ...toggleSwitchDefaultVariants, ...compact(variants) })

export const toggleSwitch = /* @__PURE__ */ Object.assign(toggleSwitchFn, {
  __recipe__: false,
  __name__: 'toggleSwitch',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: toggleSwitchVariantKeys,
  variantMap: {
  "size": [
    "sm",
    "md"
  ],
  "disabled": [
    "true"
  ],
  "description": [
    "true",
    "false"
  ],
  "descriptionDirection": [
    "horizontal",
    "vertical"
  ],
  "labelPlacement": [
    "left",
    "right"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, toggleSwitchVariantKeys)
  },
  getVariantProps
})